import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { getCurrentTime16j9973nx5x63 as getCurrentTime } from './internal/KLoggingClock.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  hashCodeq5arwsb9dgti as hashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getBigIntHashCode294hi5bdhtj6e as getBigIntHashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var KLoggingEventClass;
function KLoggingEvent() {
  if (KLoggingEventClass === VOID) {
    class $ {
      static d2g(level, marker, loggerName, message, cause, payload, timestamp) {
        message = message === VOID ? null : message;
        cause = cause === VOID ? null : cause;
        payload = payload === VOID ? null : payload;
        timestamp = timestamp === VOID ? getCurrentTime() : timestamp;
        var $this = createThis(this);
        $this.k2f_1 = level;
        $this.l2f_1 = marker;
        $this.m2f_1 = loggerName;
        $this.n2f_1 = message;
        $this.o2f_1 = cause;
        $this.p2f_1 = payload;
        $this.q2f_1 = timestamp;
        return $this;
      }
      static e2g(level, marker, loggerName, eventBuilder) {
        return this.d2g(level, marker, loggerName, eventBuilder.v2f_1, eventBuilder.w2f_1, eventBuilder.x2f_1);
      }
      toString() {
        return 'KLoggingEvent(level=' + this.k2f_1.toString() + ', marker=' + toString(this.l2f_1) + ', loggerName=' + this.m2f_1 + ', message=' + this.n2f_1 + ', cause=' + toString(this.o2f_1) + ', payload=' + toString(this.p2f_1) + ', timestamp=' + this.q2f_1.toString() + ')';
      }
      hashCode() {
        var result = this.k2f_1.hashCode();
        result = imul(result, 31) + (this.l2f_1 == null ? 0 : hashCode(this.l2f_1)) | 0;
        result = imul(result, 31) + getStringHashCode(this.m2f_1) | 0;
        result = imul(result, 31) + (this.n2f_1 == null ? 0 : getStringHashCode(this.n2f_1)) | 0;
        result = imul(result, 31) + (this.o2f_1 == null ? 0 : hashCode(this.o2f_1)) | 0;
        result = imul(result, 31) + (this.p2f_1 == null ? 0 : hashCode(this.p2f_1)) | 0;
        result = imul(result, 31) + getBigIntHashCode(this.q2f_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof KLoggingEvent()))
          return false;
        var tmp0_other_with_cast = other instanceof KLoggingEvent() ? other : THROW_CCE();
        if (!this.k2f_1.equals(tmp0_other_with_cast.k2f_1))
          return false;
        if (!equals(this.l2f_1, tmp0_other_with_cast.l2f_1))
          return false;
        if (!(this.m2f_1 === tmp0_other_with_cast.m2f_1))
          return false;
        if (!(this.n2f_1 == tmp0_other_with_cast.n2f_1))
          return false;
        if (!equals(this.o2f_1, tmp0_other_with_cast.o2f_1))
          return false;
        if (!equals(this.p2f_1, tmp0_other_with_cast.p2f_1))
          return false;
        if (!(this.q2f_1 === tmp0_other_with_cast.q2f_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'KLoggingEvent');
    KLoggingEventClass = $;
  }
  return KLoggingEventClass;
}
//region block: exports
export {
  KLoggingEvent as KLoggingEvent3el01063mcenm,
};
//endregion

//# sourceMappingURL=KLoggingEvent.mjs.map
